import { module } from 'angular';
import FullscreenLoaderController from './model/fullscreen-loader';

export default module('app')
	.controller('FullscreenLoaderController', FullscreenLoaderController);
